import { ComponentProps, Suspense } from "react";

import { useSidebar } from "@/components/elements/Sidebar";
import cn from "@/helpers/classNames";
import { useMountEffect } from "@/hooks/useMountEffect";
import { Outlet } from "@tanstack/react-location";

import { SettingsNav } from "./SettingsNav";

function ContentWrapper(props: ComponentProps<"div">) {
  return (
    <div
      className={cn(
        "mx-auto w-full max-w-8xl px-4 md:px-6 lg:px-8",
        props.className,
      )}
    >
      {props.children}
    </div>
  );
}

export function SettingsLayout() {
  const { toggleCollapseState } = useSidebar();
  useMountEffect(() => toggleCollapseState(true));
  return (
    <div className="overflow-y-auto">
      <main className="h-full">
        <header className="border-b bg-gray-50/95 dark:bg-gray-900/95">
          <ContentWrapper className="flex h-12 items-center">
            <h1 className="text-base">Account Settings</h1>
          </ContentWrapper>
        </header>
        <ContentWrapper className="mt-8">
          <div className="flex flex-col gap-4 sm:flex-row lg:gap-8">
            <div className="shrink-0 sm:w-58">
              {/* p-1 keeps the items' focus outline inside the scroll clip. */}
              <SettingsNav className="sticky top-4 -m-1 [scrollbar-width:none] p-1 sm:max-h-[calc(100dvh-6rem)] sm:overflow-y-auto [&::-webkit-scrollbar]:hidden" />
            </div>
            <div className="min-w-0 grow pb-8">
              <Suspense fallback={<div>Loading...</div>}>
                <Outlet />
              </Suspense>
            </div>
          </div>
        </ContentWrapper>
      </main>
    </div>
  );
}
